module.exports = __webpack_public_path__ + "img/xls.8e77ff39.svg";